import { ReactNode } from 'react';

export const DOCX_EXTENSION = '.docx';
export const DOC_EXTENSION = '.doc';
export const PPT_EXTENSION = '.ppt';
export const PPTX_EXTENSION = '.pptx';
export const PDF_EXTENSION = '.pdf';
export const JPEG_EXTENSION = '.jpeg';
export const JPG_EXTENSION = '.jpg';
export const PNG_EXTENSION = '.png';
export const RIVE_EXTENSION = '.riv';
export const GIF_EXTENSION = '.gif';
export const MP3_EXTENSION = '.mp3';
export const CSV_EXTENSION = '.csv';
export const XLSX_EXTENSION = '.xlsx';
export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/png'];
export const PDF_DOCUMENT_MIMETYPE = 'application/pdf';
export const CSV_MIME_TYPE = 'text/csv';
export const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const WORD_DOCUMENT_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const WORD_DOCUMENT_MIMETYPES = [
  'application/msword',
  WORD_DOCUMENT_TYPE,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
];
export const PPT_MIME_TYPE = 'application/vnd.ms-powerpoint';
export const PPTX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const IMAGE_EXTENSIONS = [JPEG_EXTENSION, JPG_EXTENSION, PNG_EXTENSION];
export const WORD_DOCUMENT_EXTENSIONS = [DOC_EXTENSION, DOCX_EXTENSION];
export const POWERPOINT_DOCUMENT_EXTENSIONS = [PPTX_EXTENSION, PPT_EXTENSION];
export const POWERPOINT_DOCUMENT_MIMETYPES = [
  PPT_MIME_TYPE,
  PPTX_MIME_TYPE,
  ...POWERPOINT_DOCUMENT_EXTENSIONS,
];
export const DOCUMENT_MIMETYPES = [
  PDF_DOCUMENT_MIMETYPE,
  PDF_EXTENSION,
  ...WORD_DOCUMENT_MIMETYPES,
  ...WORD_DOCUMENT_EXTENSIONS,
];

export const UPLOAD_ERROR =
  'There was an error uploading your file. Please try again later.';
export const TOO_LARGE_ERROR =
  'This file size is too big. Please reduce it to below';
export const ENTITY_TOO_LARGE = 'EntityTooLarge';
export const FILE_TYPE_ERROR_CODE = 'file-invalid-type';
export const FILE_SIZE_ERROR_CODE = 'file-too-large';
export type S3KeyMapping = {
  [key: string]: string;
};

export const ACCEPT_TYPE_PDF = 'Pdf';
export const ACCEPT_TYPE_IMAGE = 'Image';
export const ACCEPT_TYPE_WORD = 'Word';
export const ACCEPT_TYPE_POWERPOINT = 'Powerpoint';
export const ACCEPT_TYPE_RIVE = 'Rive';
export const ACCEPT_TYPE_GIF = 'Gif';
export const ACCEPT_TYPE_AUDIO = 'Audio';
export const ACCEPT_TYPE_CSV = 'Csv';
export const ACCEPT_TYPE_XLSX = 'Xlsx';

export type AcceptTypes = (
  | typeof ACCEPT_TYPE_PDF
  | typeof ACCEPT_TYPE_IMAGE
  | typeof ACCEPT_TYPE_WORD
  | typeof ACCEPT_TYPE_POWERPOINT
  | typeof ACCEPT_TYPE_RIVE
  | typeof ACCEPT_TYPE_GIF
  | typeof ACCEPT_TYPE_AUDIO
  | typeof ACCEPT_TYPE_CSV
  | typeof ACCEPT_TYPE_XLSX
)[];

export type Props = {
  label?: ReactNode;
  placeholder?: ReactNode;
  // comma separated list of mimes see https://react-dropzone.js.org/#accepting-specific-file-types
  accept?: AcceptTypes;
  value?: string;
  source?: string;
  thumbnailStyling?: boolean;
  inputDataSelector?: null | string;
  square?: boolean;
  name: string;
  onChange: (key: string, fileName: string, file: File) => void;
  error?: string;
  disabled?: boolean;
  validationError?: string;
  isLoading?: boolean;
  isFinishing?: boolean;
  fileMetaData?: string;
  maxSizeInMb?: number;
  onSelectPagePreview?: () => void;
  onFileRemoved?: () => void;
  skipS3Upload?: boolean;
};
